import { useState } from "react";
import {
  useGetTriviaUserStatsQuery,
  useGetTriviaUserAchievementsQuery,
  useGetTriviaGameHistoryQuery,
} from "../store/api/mlbApi";

const HISTORY_PAGE_SIZE = 25;

/**
 * Custom hook for trivia user statistics and achievements
 */
export const useTriviaStats = () => {
  const [historyPage, setHistoryPage] = useState(1);
  const {
    data: statsData,
    isLoading: isLoadingStats,
    error: statsError,
    refetch: refetchStats,
  } = useGetTriviaUserStatsQuery();
  const {
    data: achievementsData,
    isLoading: isLoadingAchievements,
    error: achievementsError,
    refetch: refetchAchievements,
  } = useGetTriviaUserAchievementsQuery();
  const {
    data: historyData,
    isLoading: isLoadingHistory,
    error: historyError,
    refetch: refetchHistory,
  } = useGetTriviaGameHistoryQuery({
    page: historyPage,
    pageSize: HISTORY_PAGE_SIZE,
  });

  return {
    // User stats
    userStats: statsData?.userStats || null,
    isLoadingStats,
    statsError,

    // Achievements
    achievements: achievementsData?.achievements || [],
    isLoadingAchievements,
    achievementsError,

    // Game history
    gameHistory: historyData?.history || [],
    historyPagination: historyData?.pagination || null,
    historyPage,
    setHistoryPage,
    isLoadingHistory,
    historyError,

    // Computed values
    isLoading: isLoadingStats || isLoadingAchievements || isLoadingHistory,
    hasError: !!(statsError || achievementsError || historyError),

    // Refetch function
    refetch: async () => {
      await Promise.all([
        refetchStats(),
        refetchAchievements(),
        refetchHistory(),
      ]);
    },
  };
};
